<template>
  <q-layout view="hHh lpR fFf">
    <app-header
      ref="header"
      :brand-logo="$config.branding.header.logo"
      :brand-text="$config.branding.header.text"
    />

    <q-page-container>
      <router-view />
    </q-page-container>
  </q-layout>
</template>

<script>
import { QLayout, QPageContainer } from 'quasar'
import AppHeader from 'components/BasicLayout/AppHeader.vue'

export default {
  name: 'MainLayout',
  components: { AppHeader, QLayout, QPageContainer }
}
</script>
